import React from "react";
import { Card, Col, Row, Space, Radio, Checkbox, Input } from "antd";
import { MrRow, MrColumn } from "../../components/UI/MrTable/MrTable";
import "./Disorder.scss";
import InputWithTags from "../../components/UI/Input/InputWithTags";

const DisorderItemDetail = (props) => {
  const disorderData = props.item;
  console.log("props in disorder==>", disorderData.form_json.disorders);
  return (
    <>
      <div className="section-card-show">
        <MrRow className="section-field-row">
          <MrColumn style={{ flex: 4 }}>Disorder ID</MrColumn>
          <MrColumn style={{ flex: 20 }} className="field-value">
            <p class="disorder-id">{disorderData.id}</p>
          </MrColumn>
        </MrRow>
        <MrRow className="section-field-row">
          <MrColumn style={{ flex: 4 }}>Disorder name</MrColumn>
          <MrColumn style={{ flex: 20 }} className="field-value">
            <p class="disorder-name">{disorderData.name}</p>
          </MrColumn>
        </MrRow>
        <MrRow className="section-field-row">
          <MrColumn style={{ flex: 4 }}>Symptoms</MrColumn>
          <MrColumn style={{ flex: 20 }} className="field-value">
            <p class="disorder-remarks">{disorderData.remarks}</p>
          </MrColumn>
        </MrRow>
        <MrRow className="section-field-row">
          <MrColumn style={{ flex: 4 }}>Abbreviation</MrColumn>
          <MrColumn style={{ flex: 20 }} className="field-value">
            <p class="disorder-remarks">{disorderData.remarks}</p>
          </MrColumn>
        </MrRow>
        <MrRow className="section-field-row">
          <MrColumn style={{ flex: 4 }}>Remarks</MrColumn>
          <MrColumn style={{ flex: 20 }} className="field-value">
            <p class="disorder-remarks">{disorderData.remarks}</p>
          </MrColumn>
        </MrRow>
      </div>
      <div>
        {disorderData.form_json.disorders.length !== 0 &&
          disorderData.form_json.disorders.map((disorder, index) => (
            <Card
              type="inner"
              title={disorder.title}
              key={disorder.id}
              className="main-card"
            >
              <Row gutter={16}>
                {disorder.subSectionsList.length !== 0 &&
                  disorder.subSectionsList.map((disorderDetail, nestedIndex) =>
                    disorderDetail.hasOwnProperty("is_sub_heading") ? (
                      <Col span={disorderDetail.span} className="heading">
                        <Space>
                          <p>{disorderDetail.sub_heading_title}</p>
                        </Space>
                      </Col>
                    ) : (
                      <Col span={disorderDetail.span} className="subsection">
                        <Space className="subsection-title">
                          {disorderDetail.title}
                        </Space>
                        <br />
                        {disorderDetail.widget === "RadioGroupWidget" &&
                          disorderDetail.options.length !== 0 &&
                          disorderDetail.options.map((option) => (
                            <Space className="options" style={{ flex: 1 }}>
                              <Radio.Group>
                                <Radio value={option.title}>
                                  {option.title}
                                </Radio>
                              </Radio.Group>
                            </Space>
                          ))}
                        {disorderDetail.widget === "CheckboxGroupWidget" &&
                          disorderDetail.options.length !== 0 &&
                          disorderDetail.options.map((option) => (
                            <Space className="options" style={{ flex: 1 }}>
                              <Checkbox.Group>
                                <Checkbox value={option.title}>
                                  {option.title}
                                </Checkbox>
                              </Checkbox.Group>
                            </Space>
                          ))}
                        {disorderDetail.widget === "string" && (
                          <Input
                            placeholder="Text"
                            placeholder={disorderDetail.title}
                          />
                        )}
                        {disorderDetail.widget === "InputWithTags" && (
                          <InputWithTags placeholderValue={disorderDetail.title} />
                        )}
                      </Col>
                    )
                  )}
              </Row>
            </Card>
          ))}
      </div>
    </>
  );
};

export default DisorderItemDetail;
